import React from 'react'
import { CardWithIcon } from '../../elements/CardWithIcon'
import { IProps } from './index'
import { Text } from '../../elements/Text'
import { mq, containerMaxWidth } from '../../utils'
import edgeTexture from '../../images/edge-texture.svg'

import { CardsWithIcon as CardsWithIconDefault } from './component'
import { BrandOptions, useBrand } from '../../providers/brandProvider'

export const CardsWithIcon: React.FC<IProps> = (props: IProps) => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <CardsWithIconDefault {...props} />
  }
  return <CardsWithIconLegacy {...props} />
}

const CardsWithIconLegacy: React.FC<IProps> = ({ header, subheader, cards }) => (
  <div className="card-with-icons-wrapper">
    <h1 className="header">
      <Text size="xxl+">{header}</Text>
    </h1>

    {subheader && (
      <div className="subheader">
        <Text size="md">{subheader}</Text>
      </div>
    )}

    <ul className="content">
      {cards.map((card, index) => (
        <li key={index}>
          <CardWithIcon {...card} />
        </li>
      ))}
    </ul>

    <style jsx>
      {`
        .card-with-icons-wrapper {
          display: grid;
          grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;
          grid-template-rows: [header] auto [subheader] auto [cards] auto;
          background-color: $light-gray-legacy;
          position: relative;
          padding: 75px 0;
        }

        .card-with-icons-wrapper:after,
        .card-with-icons-wrapper:before {
          content: '';
          position: absolute;
          background-color: $light-gray-legacy;
          height: 18px;
          left: 0;
          mask-repeat: repeat no-repeat;
          width: 106vw;
          z-index: -1;
          mask-image: url(${edgeTexture});
          left: -3vw;
        }

        .card-with-icons-wrapper:before {
          top: -18px;
          transform: rotate(180deg);
        }

        .card-with-icons-wrapper:after {
          bottom: -18px;
        }

        .header {
          grid-row: header;
          grid-column: content;
          text-align: center;
          margin-bottom: 32px;
          margin-left: auto;
          margin-right: auto;
        }

        .subheader {
          grid-row: subheader;
          grid-column: content;
          text-align: center;
          margin-bottom: 60px;
        }

        .content {
          grid-column: content;
          grid-row: cards;
          width: 100%;
          justify-items: center;
          grid-row-gap: 62px;
          max-width: ${containerMaxWidth};
          margin: 0 auto;
        }

        .content li {
          padding-bottom: 20px;
        }

        @media (${mq.tablet}) {
          .content {
            display: flex;
            flex-wrap: wrap-reverse;
            justify-content: center;
          }

          .content li {
            flex-basis: 33%;
            padding: 20px;
          }
        }

        @media (${mq.desktop}) {
          .card-with-icons-wrapper {
            padding: 120px 0;
          }

          .header {
            max-width: 790px;
          }

          .content {
            display: grid;
            grid-template-columns: 1fr;
            grid-column-gap: 20px;
            grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
            grid-row-gap: 0;
          }

          .content li {
            padding: 0;
          }
        }
      `}
    </style>
  </div>
)
